import cn from 'classnames'
import { PhoneInput } from 'legacy/lut/components/common/phoneInput/PhoneInput'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { useFormField } from 'cng-common/features//form'
import { ValidationType } from 'cng-common/features//form/configs'
import { ReadOnlyField } from 'cng-common/features/form/components'

import { IFormPhoneInputProps } from './models'

import styles from './FormPhoneInput.module.scss'

export const FormPhoneInput: FC<IFormPhoneInputProps> = ({
  isDisabled,
  isReadOnly,
  isVisible = true,
  isPhoneCodeRequired,
  isPhoneNumberRequired,
  formKey,
  phoneNumberFieldName,
  onPhoneNumberChange,
  phoneCodeFieldName,
  onPhoneCodeValidate,
  onPhoneCodeChange,
  onPhoneNumberValidate,
  phoneNumberValue,
  phoneCodeValue,
  label,
  validationType,
}) => {
  const {
    value: formPhoneNumber,
    handleChange: handlePhoneNumberChange,
    handleBlur: handlePhoneNumberBlur,
    validationMessage: validatePhoneNumberMessage,
    isModified: isPhoneNumberModified,
  } = useFormField<string>({
    defaultValue: phoneNumberValue,
    field: phoneNumberFieldName,
    formKey: formKey,
    onChange: onPhoneNumberChange,
    onValidate: onPhoneNumberValidate,
    isDisabled,
    isRequired: isPhoneNumberRequired,
    isVisible,
    validationType,
  })
  const {
    value: formPhoneCode,
    handleChange: handlePhoneCodeChange,
    handleBlur: handlePhoneCodeBlur,
    validationMessage: validationPhoneCodeMessage,
    isModified: isPhoneCodeModified,
  } = useFormField<string>({
    defaultValue: phoneCodeValue,
    field: phoneCodeFieldName,
    formKey: formKey,
    onChange: onPhoneCodeChange,
    onValidate: onPhoneCodeValidate,
    isDisabled,
    isRequired: isPhoneCodeRequired,
    validationType: validationType || ValidationType.ONCHANGE,
  })

  const [t] = useTranslation()

  if (isReadOnly) {
    const readOnlyValue = formPhoneNumber ? `+${formPhoneCode || ''}${formPhoneNumber || ''}` : '-'

    return <ReadOnlyField label={label} value={readOnlyValue} />
  }

  if (isVisible) {
    return (
      <PhoneInput
        label={t(label)}
        isDisabled={isDisabled}
        phoneCodeClasses={{
          controlClasses: {
            root: cn({
              [styles.phoneCodeRequired]: isPhoneCodeRequired,
              [styles.modified]: isPhoneCodeModified,
            }),
          },
        }}
        phoneNumberClasses={{
          inputClasses: {
            root: cn({
              [styles.phoneNumberRequired]: isPhoneNumberRequired,
              [styles.modified]: isPhoneNumberModified,
            }),
          },
        }}
        phoneNumberValue={formPhoneNumber}
        phoneCodeValue={formPhoneCode}
        onPhoneCodeChange={handlePhoneCodeChange}
        onPhoneNumberChange={handlePhoneNumberChange}
        onPhoneNumberBlur={handlePhoneNumberBlur}
        onPhoneCodeBlur={handlePhoneCodeBlur}
        phoneNumberErrorMessage={validatePhoneNumberMessage}
        phoneCodeErrorMessage={validationPhoneCodeMessage}
      />
    )
  }

  return null
}
